export enum ElegibilidadeBrf {
    /// <summary>
    /// BRF PADRAO A
    /// </summary>
    BRF_A = 1,

    /// <summary>
    /// BRF PADRAO B
    /// </summary>
    BRF_B = 2,

    /// <summary>
    /// BRF PADRAO C
    /// </summary>
    BRF_C = 3,

    /// <summary>
    /// Elegível BRF Spot
    /// </summary>
    BRF_Spot = 4,

    /// <summary>
    /// Elegível BRF OTM
    /// </summary>
    BRF_OTM = 5,

    /// <summary>
    /// Elegível BRF INELEGIVEL
    /// </summary>
    BRF_INELEGIVEL = 6,
}
